import * as React from "react"
import { Button as CommonButton } from "@chakra-ui/react"
import { IButtonProps } from "./buttons.interface"
import { useTranslation } from "react-i18next"

const _Button: React.FC<IButtonProps> = props => {
  const { t } = useTranslation()
  const { buttonRef, text, ...otherProps } = props
  return (
    <CommonButton
      ref={buttonRef}
      {...otherProps}
      _selected={{}}
      _active={{}}
      _focus={{}}
    >
      {t(props.text)}
      {props.children}
    </CommonButton>
  )
}

export const Button = React.memo(_Button)
